"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";
import SubMenuLink from "@/components/nav/sub-menu";

type DropdownItem = {
  label: string;
  href: string;
};

type MobileMenuDropdownProps = {
  label: string;
  items: DropdownItem[];
  onItemClick?: () => void;
};

export default function MobileMenuDropdown({ label, items, onItemClick }: Readonly<MobileMenuDropdownProps>) {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex w-full items-center justify-between px-5 py-4 hover:bg-gray-50 hover:text-primary transition-colors"
      >
        <span>{label}</span>

        <ChevronDown
          size={18}
          className={`transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </button>

      <div
        className={`overflow-hidden transition-all duration-300 ${
          open ? "max-h-64" : "max-h-0"
        }`}
      >
        <div className="bg-gray-50/70 py-1">
          {items.map((item) => (
            <SubMenuLink
              key={item.href}
              href={item.href}
              onClick={() => {
                onItemClick?.();
                setOpen(false);
              }}
            >
              {item.label}
            </SubMenuLink>
          ))}
        </div>
      </div>
    </div>
  );
}